var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#ECECEC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#000",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.449 9.468v.18h.6v-.12c0-1.49 1.89-1.62 1.89-3.23 0-.95-.74-1.8-2.07-1.8-1.28 0-2.18.79-2.17 2.19h.63c0-1.14.67-1.69 1.54-1.69.81 0 1.45.47 1.45 1.28 0 1.43-1.87 1.5-1.87 3.19Zm-.4 1.66c0 .38.32.7.7.7.39 0 .7-.32.7-.7 0-.39-.31-.69-.7-.69-.38 0-.7.3-.7.69Z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.9d2d899d373ebf6a4e3638d7fb7323fa.svg";
export { ForwardRef as ReactComponent };